import { useDebugValue } from 'react';
import { ContentType, useConditionalContentContext } from '../../../contexts';
import { useClauseFieldPath } from './useClauseFieldPath';

export const useContentFieldPath = () => {
  const { type } = useConditionalContentContext();
  const clauseFieldPath = useClauseFieldPath();
  const fieldPath =
    type === ContentType.Conditional
      ? (`${clauseFieldPath}.content` as const)
      : ('conditionalContent.defaultContent' as const);
  useDebugValue(fieldPath);
  return fieldPath;
};
